/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankCardVo
 */
export interface BankCardVo {
    /**
     * 银行卡ID
     * @type {number}
     * @memberof BankCardVo
     */
    id?: number;
    /**
     * 用户id
     * @type {number}
     * @memberof BankCardVo
     */
    userId?: number;
    /**
     * 用户编号
     * @type {string}
     * @memberof BankCardVo
     */
    userCode?: string;
    /**
     * 用户姓名
     * @type {string}
     * @memberof BankCardVo
     */
    userName?: string;
    /**
     * 卡类型  1 储蓄卡 2 信用卡
     * @type {number}
     * @memberof BankCardVo
     */
    cardType?: number;
    /**
     * 卡号
     * @type {string}
     * @memberof BankCardVo
     */
    cardNumber?: string;
    /**
     * 是否默认 0 不是， 1 是
     * @type {number}
     * @memberof BankCardVo
     */
    defaultChoice?: number;
    /**
     * 银行名
     * @type {string}
     * @memberof BankCardVo
     */
    bankName?: string;
    /**
     * 存款人
     * @type {string}
     * @memberof BankCardVo
     */
    cardHolderName?: string;
    /**
     * 是否可用 0 不可用，1 可用
     * @type {number}
     * @memberof BankCardVo
     */
    enable?: number;
    /**
     * 卡业务类型 1 佣金收款 2 支付
     * @type {number}
     * @memberof BankCardVo
     */
    businessType?: number;
    /**
     * 卡业务类型名称（多语言）
     * @type {string}
     * @memberof BankCardVo
     */
    businessTypeName?: string;
}

/**
 * Check if a given object implements the BankCardVo interface.
 */
export function instanceOfBankCardVo(value: object): value is BankCardVo {
    return true;
}

export function BankCardVoFromJSON(json: any): BankCardVo {
    return BankCardVoFromJSONTyped(json, false);
}

export function BankCardVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankCardVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'cardType': json['cardType'] == null ? undefined : json['cardType'],
        'cardNumber': json['cardNumber'] == null ? undefined : json['cardNumber'],
        'defaultChoice': json['defaultChoice'] == null ? undefined : json['defaultChoice'],
        'bankName': json['bankName'] == null ? undefined : json['bankName'],
        'cardHolderName': json['cardHolderName'] == null ? undefined : json['cardHolderName'],
        'enable': json['enable'] == null ? undefined : json['enable'],
        'businessType': json['businessType'] == null ? undefined : json['businessType'],
        'businessTypeName': json['businessTypeName'] == null ? undefined : json['businessTypeName'],
    };
}

export function BankCardVoToJSON(json: any): BankCardVo {
    return BankCardVoToJSONTyped(json, false);
}

export function BankCardVoToJSONTyped(value?: BankCardVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'userId': value['userId'],
        'userCode': value['userCode'],
        'userName': value['userName'],
        'cardType': value['cardType'],
        'cardNumber': value['cardNumber'],
        'defaultChoice': value['defaultChoice'],
        'bankName': value['bankName'],
        'cardHolderName': value['cardHolderName'],
        'enable': value['enable'],
        'businessType': value['businessType'],
        'businessTypeName': value['businessTypeName'],
    };
}

